import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core'
import { FormGroup } from '@angular/forms'
import { EnderecoModel, MunicipioModel, UFDomainModel } from '@shared/models/backend'
import { debounceTime, distinctUntilChanged } from 'rxjs/operators'
import { FormHelperService } from 'src/app/widgets/form/services/form-helper.service'
import {
  createDefaultSelectFieldProvider,
  SelectFieldProvider,
} from 'src/app/widgets/select-field/select-field-provider'
import { EnderecoService } from './endereco.service'
import { enderecoReferenceModel } from './model/endereco-model'

@Component({
  selector: 'app-endereco',
  templateUrl: './endereco.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EnderecoComponent implements OnInit {
  @Input()
  formGroup: FormGroup
  @Input()
  controlPath: string
  @Input()
  leftEmptyCol: string
  municipiosProvider: SelectFieldProvider<MunicipioModel>

  get form() {
    return this.formGroup.get(this.controlPath) as FormGroup
  }

  constructor(
    private formHelper: FormHelperService,
    private service: EnderecoService,
    private ref: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.municipiosProvider = createDefaultSelectFieldProvider<MunicipioModel>([])
    this.initForm()
  }

  initForm() {
    this.formGroup.setControl(
      this.controlPath,
      this.formHelper.createForm<EnderecoModel>(enderecoReferenceModel, this.form.getRawValue())
    )
    this.form.controls.municipio.valueChanges
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(this.onMunicipioChanged)
    this.form.controls.uf.valueChanges.subscribe(this.onUfChanged)
    this.form.controls.semCEP.valueChanges.subscribe(this.onSemCEPChanged)
    this.form.controls.semNumero.valueChanges.subscribe(this.onSemNumeroChanged)
    this.formGroup.statusChanges.subscribe((_) => this.ref.markForCheck())
    this.form.controls.semCEP.updateValueAndValidity()
    this.form.controls.semNumero.updateValueAndValidity()
    this.form.controls.uf.updateValueAndValidity()
  }

  onCepChange() {
    this.form.controls.cep.markAsTouched()
    if (this.form.controls.cep.valid) {
      this.service.handleCepSearch(this.form, this.form.controls.cep.value)
    } else {
      this.service.handleCepReset(this.form)
    }
  }

  onUfChanged = (uf: UFDomainModel) => {
    this.service.handleUFChanged(this.form, this.municipiosProvider, uf)
  }

  onMunicipioChanged = (search: string) => {
    this.service.handleMunicipioChanged(this.form.controls.uf, this.ref, this.municipiosProvider, search)
  }

  onMunicipioInvalid() {
    this.service.handleMunicipioChanged(this.form.controls.uf, this.ref, this.municipiosProvider, '')
  }

  onSemCEPChanged = (semCEP: boolean) => {
    this.service.handleSemCEPChanged(this.form, semCEP)
  }

  onSemNumeroChanged = (semNumero: boolean) => {
    this.service.handleSemNumeroChanged(this.form, semNumero)
  }
}
